<template>
  <el-dialog
    title="提示"
    :visible.sync="dialogVisible"
    @opened="dialogOpen"
  >


    <el-form
            ref="form"
            :model="form"
            label-width="100px"
            size="small"
    >
      <el-form-item
              prop="generation_num"
              label="生成数量"
              :rules="[{ required: true, message: '不能为空'}]"
      >

        <el-radio-group v-model="form.activeName" style="margin-bottom: 30px;"  @change="agreeChange">
          <el-radio-button label="100">100</el-radio-button>
          <el-radio-button label="500">500</el-radio-button>
          <el-radio-button label="1000">1000</el-radio-button>
        </el-radio-group>

          <el-input
                  v-model="form.generation_num"
                  placeholder="生成数量"
          />
      </el-form-item>
      <el-form-item>
      <el-button
              type="primary"
              :loading="loading"
              @click="saveUser"
      >确定</el-button>
      <el-button @click="close">取消</el-button>
      </el-form-item>
    </el-form>





  </el-dialog>

</template>
<style>

  .bg-purple-dark {
    background: #e5e9f2;
  }
</style>
<script>
    import * as agentService from "@/api/sys/agent";
    import * as userService from "@/api/sys/user";
    import util from '@/libs/util.js'
export default {
  name: "payconfigureEditForm",
  props: {
      agent: Object,
    value: Boolean
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      form: {
          generation_num:"0",
          activeName :'0'
      }
    };
  },
  watch: {
    value(val) {
      this.dialogVisible = val;
    },
      accuseVisible (newValue, oldValue) {
          console.log("-----"+newValue);
      },
      dialogVisible(val) {
      this.$emit("input", val);
    }
  },
  methods: {
      agreeChange:function(val){
          console.log("========="+val);
          if(val == '100'){
              // 触发‘用户管理’事件
              this.form.generation_num = "100";
          }else if(val == '500'){
              // 触发‘用户管理’事件
              this.form.generation_num = "500";
          }else if(val == '1000'){
              // 触发‘用户管理’事件
              this.form.generation_num = "1000";
          }
      },
    dialogOpen() {
      this.$refs.form.resetFields();
        //this.form.remarks=this.agent.remarks;

    },
    saveUser() {
      this.$refs["form"].validate(valid => {
        if (valid) {
                this.loading = true;
                agentService.savePaymentcode({ ...this.form,agentid:util.cookies.get('agentid')})
                    .then(data => {
                        this.loading = false;
                        this.dialogVisible = false;
                        this.$emit("submit");
                    });
        } else {
          return false;
        }
      });
    },
    close() {
      this.$refs["form"].resetFields();
      this.dialogVisible = false;
    }
  }
};
</script>

